import LicenseLimitedModal, {
  LicenseLimitedModalPropsBase,
} from "@/components/modal/license-limited-modals/license-limited-modal";
import React from "react";

const VocalRemoverCountLimitedModal = ({
  licenseName,
}: LicenseLimitedModalPropsBase) => {
  return (
    <LicenseLimitedModal
      licenseName={licenseName}
      upgradeToMessage={"remove vocals"}
      allowsMessage={""}
      shouldNavigateToPricing={true}
    />
  );
};

export default VocalRemoverCountLimitedModal;
